// Translations for the Public QR Scanner and its sub-forms.
export const translations = {
  ar: {
    headerTitle: "Lucent Dental Center Company",
    headerSubtitle: "",
    scanQR: "مسح رمز QR",
    scanDescription: "قم بمسح رمز QR الموجود داخل العيادة للإبلاغ عن مشكلة صيانة",
    startScan: "بدء المسح",
    cancelScan: "إلغاء المسح",
    requestDetails: "تفاصيل طلب الصيانة",
    name: "الاسم",
    namePlaceholder: "اسمك",
    phone: "رقم الجوال (اختياري)",
    phonePlaceholder: "05xxxxxxxx",
    whatsapp: "رقم واتساب (للإشعارات)",
    whatsappPlaceholder: "+966500000000",
    elementType: "نوع العنصر",
    selectElementType: "اختر نوع العنصر",
    structural: "إنشائي",
    medical: "طبي",
    it: "تقنية المعلومات",
    category: "الفئة",
    selectCategory: "اختر الفئة",
    priority: "الأولوية",
    priorityLow: "منخفضة - يمكن الانتظار",
    priorityMedium: "متوسطة - خلال أيام",
    priorityHigh: "عالية - مطلوب بسرعة",
    priorityUrgent: "عاجلة - يؤثر على العمل",
    description: "وصف المشكلة",
    descriptionPlaceholder: "صف المشكلة بالتفصيل...",
    addPhotos: "إضافة صور (مطلوب)",
    clickToUpload: "اضغط لرفع الصور",
    maxPhotos: "الحد الأقصى 5 صور - مطلوب صورة واحدة على الأقل",
    submitRequest: "إرسال طلب الصيانة",
    submitting: "جاري الإرسال...",
    scanAnother: "مسح عيادة أخرى",
    successTitle: "تم إرسال الطلب بنجاح!",
    successMessage: "شكراً لك، سيتم مراجعة طلبك والتواصل معك قريباً",
    submitAnother: "إرسال طلب آخر",
    copyright: "© 2026 شركة مركز لوسنت للأسنان",
    fillRequired: "يرجى ملء جميع الحقول المطلوبة وإرفاق صورة واحدة على الأقل",
    clinicNotFound: "العيادة غير موجودة",
    invalidQR: "رمز QR غير صالح",
    uploadFailed: "فشل في رفع الصورة",
    maxPhotosError: "الحد الأقصى 5 صور",
    submitSuccess: "تم إرسال طلب الصيانة بنجاح",
    submitFailed: "فشل في إرسال الطلب",
    floor: "الطابق",
    wall: "الجدران",
    floorCat: "الأرضيات",
    ceiling: "السقف",
    lighting: "الإضاءة",
    plumbing: "السباكة",
    electrical: "الكهرباء",
    ac: "التكييف",
    doors_windows: "الأبواب والنوافذ",
    painting: "الدهانات",
    dental_chair: "كرسي الأسنان",
    xray: "جهاز الأشعة",
    sterilizer: "جهاز التعقيم",
    compressor: "الضاغط",
    suction: "جهاز الشفط",
    chairLight: "إضاءة الكرسي",
    medical_equipment: "أجهزة طبية أخرى",
    computer: "جهاز كمبيوتر",
    printer: "طابعة",
    network: "الشبكة والإنترنت",
    phone_system: "نظام الهاتف",
    software: "برامج وأنظمة",
    security_camera: "كاميرات المراقبة",
    access_control: "أنظمة الدخول",
    other: "أخرى"
  },
  en: {
    headerTitle: "Lucent Dental Center Company",
    headerSubtitle: "",
    scanQR: "Scan QR Code",
    scanDescription: "Scan the QR code inside the clinic to report a maintenance issue",
    startScan: "Start Scanning",
    cancelScan: "Cancel",
    requestDetails: "Maintenance Request Details",
    name: "Name",
    namePlaceholder: "Your name",
    phone: "Phone (Optional)",
    phonePlaceholder: "05xxxxxxxx",
    whatsapp: "WhatsApp (for notifications)",
    whatsappPlaceholder: "+966500000000",
    elementType: "Element Type",
    selectElementType: "Select element type",
    structural: "Structural",
    medical: "Medical",
    it: "Information Technology",
    category: "Category",
    selectCategory: "Select category",
    priority: "Priority",
    priorityLow: "Low - Can wait",
    priorityMedium: "Medium - Within days",
    priorityHigh: "High - Needed soon",
    priorityUrgent: "Urgent - Affects work",
    description: "Problem Description",
    descriptionPlaceholder: "Describe the problem in detail...",
    addPhotos: "Add Photos (Optional)",
    clickToUpload: "Click to upload photos",
    maxPhotos: "Maximum 5 photos",
    submitRequest: "Submit Maintenance Request",
    submitting: "Submitting...",
    scanAnother: "Scan Another Clinic",
    successTitle: "Request Submitted Successfully!",
    successMessage: "Thank you, your request will be reviewed and we will contact you soon",
    submitAnother: "Submit Another Request",
    copyright: "© 2026 Lucent Dental Center",
    fillRequired: "Please fill all required fields",
    clinicNotFound: "Clinic not found",
    invalidQR: "Invalid QR code",
    uploadFailed: "Failed to upload image",
    maxPhotosError: "Maximum 5 photos allowed",
    submitSuccess: "Maintenance request submitted successfully",
    submitFailed: "Failed to submit request",
    floor: "Floor",
    wall: "Walls",
    floorCat: "Flooring",
    ceiling: "Ceiling",
    lighting: "Lighting",
    plumbing: "Plumbing",
    electrical: "Electrical",
    ac: "Air Conditioning",
    doors_windows: "Doors & Windows",
    painting: "Painting",
    dental_chair: "Dental Chair",
    xray: "X-Ray Machine",
    sterilizer: "Sterilizer",
    compressor: "Compressor",
    suction: "Suction Unit",
    chairLight: "Chair Light",
    medical_equipment: "Other Medical Equipment",
    computer: "Computer",
    printer: "Printer",
    network: "Network & Internet",
    phone_system: "Phone System",
    software: "Software & Systems",
    security_camera: "Security Cameras",
    access_control: "Access Control",
    other: "Other"
  }
};

export const getStructuralCategories = (t) => [
  { value: "wall", label: t.wall },
  { value: "floor", label: t.floorCat },
  { value: "ceiling", label: t.ceiling },
  { value: "lighting", label: t.lighting },
  { value: "plumbing", label: t.plumbing },
  { value: "electrical", label: t.electrical },
  { value: "ac", label: t.ac },
  { value: "doors_windows", label: t.doors_windows },
  { value: "painting", label: t.painting },
  { value: "other", label: t.other }
];

export const getMedicalCategories = (t) => [
  { value: "dental_chair", label: t.dental_chair },
  { value: "xray", label: t.xray },
  { value: "sterilizer", label: t.sterilizer },
  { value: "compressor", label: t.compressor },
  { value: "suction", label: t.suction },
  { value: "light", label: t.chairLight },
  { value: "medical_equipment", label: t.medical_equipment },
  { value: "other", label: t.other }
];

export const getITCategories = (t) => [
  { value: "computer", label: t.computer },
  { value: "printer", label: t.printer },
  { value: "network", label: t.network },
  { value: "phone_system", label: t.phone_system },
  { value: "software", label: t.software },
  { value: "security_camera", label: t.security_camera },
  { value: "access_control", label: t.access_control },
  { value: "other", label: t.other }
];

export const getCategoriesByType = (elementType, t) => {
  switch (elementType) {
    case "structural": return getStructuralCategories(t);
    case "medical": return getMedicalCategories(t);
    case "it": return getITCategories(t);
    default: return [];
  }
};
